import Vue from 'vue';
import { PROJECT_SELECTION_ROUTES } from '@/constants/routes';
import config from '@/config/config.json';

class ProjectSelectionService {
	constructor() {}

	async get(isManaProject, customSelectionProjectsKey) {
		const response = await Vue.prototype.$http.get(`${config.apiUrl}${PROJECT_SELECTION_ROUTES.BASE_URL}/${PROJECT_SELECTION_ROUTES.MY_PROJECT_SELECTIONS}/${isManaProject ? "MANA" : "Global"}`);

		Vue.localStorage.set(customSelectionProjectsKey, response.data);
	}

	async create(isManaProject, projectName, checkedProducts, customSelectionProjectsKey) {
		let projectSelection = {
			productType: this.getProductTypeName(isManaProject),
			name: projectName,
			checkedProducts: checkedProducts,
		}

		const response = await Vue.prototype.$http.post(`${config.apiUrl}${PROJECT_SELECTION_ROUTES.BASE_URL}`, projectSelection);
		Vue.localStorage.set(customSelectionProjectsKey, response.data);
	}

	async update(projectSelection, customSelectionProjectsKey) {
		const response = await Vue.prototype.$http.put(`${config.apiUrl}${PROJECT_SELECTION_ROUTES.BASE_URL}/${projectSelection.id}`, projectSelection);

		let result = Vue.localStorage.get(customSelectionProjectsKey);
		const index = result.findIndex(x => x.id == response.data.id);
		result[index] = response.data;
		Vue.localStorage.set(customSelectionProjectsKey, result);
	}

	async delete(id, customSelectionProjectsKey) {
		const response = await Vue.prototype.$http.delete(`${config.apiUrl}${PROJECT_SELECTION_ROUTES.BASE_URL}/${id}`);

		if (response.data) {
			let result = Vue.localStorage.get(customSelectionProjectsKey).filter(x => x.id != id);
			Vue.localStorage.set(customSelectionProjectsKey, result);
		}
	}

	getProductTypeName(isManaProject) {
		return isManaProject ? "MANA" : "Global"
	}
}

export default new ProjectSelectionService();

